<div class="chart-wrapper" #chartWrapper [style.height]="height">
    <div *ngIf="loading" class="chart-state">Loading...</div>
    <div *ngIf="!loading && !hasData" class="chart-state">No metrics data available</div>
    <svg #chartSvg [style.display]="!loading && hasData ? 'block' : 'none'"></svg>
    <div class="chart-tooltip" #tooltip></div>
</div>
